import Swal from "sweetalert2";

export default function (context) {
    const $context = $(context);

    $context.on("click", '[data-rotate-statements-switch]', function () {
        const rotateStatementsSwitchVal = $(this).prop('checked');

        if (true === rotateStatementsSwitchVal) {
            $context.trigger('set-statements-lock-icons-visibility', [$(this)]);
        } else {
            Swal.fire({
                title: "Are you sure?",
                text: "Statements will not be rotated",
                icon: "question",
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: '<i class="label-icon bx bx-check"></i> Yes',
                showCancelButton: true,
                cancelButtonText: '<i class="label-icon bx bx-x"></i> No',
                customClass: {
                    confirmButton: 'btn btn-label btn-primary btn-min-width',
                    cancelButton: "btn btn-label btn-danger btn-min-width",
                }
            }).then((result) => {
                if (true !== result.value) {
                    $(this).prop('checked', true);
                } else {
                    const $tabPane = $(this).closest('.tab-pane');
                    $tabPane.trigger('set-statements-lock-icons-visibility', [$(this)]);
                }
            });
        }
    });
}
